<script>
import BaseCheckbox from '@/components/_base-checkbox.vue'

export default {
  name: 'ExportColumns',
  components: { BaseCheckbox },
  emits: ['selected-columns'],
  data() {
    return {
      selectAll: true,
      selectedColumns: {},
    }
  },
  computed: {
    columns() {
      return {
        Date: this.$t('exportBookings.columns.date'),
        Educator: this.$t('exportBookings.columns.educator'),
        Time: this.$t('exportBookings.columns.time'),
        Status: this.$t('exportBookings.columns.status'),
        Classification: this.$t('exportBookings.columns.classification'),
        Room: this.$t('exportBookings.columns.room'),
        Replacing: this.$t('exportBookings.columns.replacing'),
        Grade: this.$t('exportBookings.columns.grade'),
        Certification: this.$t('exportBookings.columns.certification'),
        Client: this.$t('exportBookings.columns.client'),
        Location: this.$t('exportBookings.columns.location'),
        Note: this.$t('exportBookings.columns.note'),
      }
    },
  },
  created() {
    this.initializeColumns()
  },
  methods: {
    initializeColumns() {
      for (const key in this.columns) {
        this.$set(this.selectedColumns, key, true)
      }
      this.$emit('selected-columns', this.selectedColumns)
    },
    toggleAllColumns() {
      this.selectAll = !this.selectAll
      for (const key in this.selectedColumns) {
        this.selectedColumns[key] = this.selectAll
      }
      this.$emit('selected-columns', this.selectedColumns)
    },
    toggleColumn(key) {
      this.selectedColumns[key] = !this.selectedColumns[key]
      this.selectAll = Object.values(this.selectedColumns).every(Boolean)
      this.$emit('selected-columns', this.selectedColumns)
    },
  },
}
</script>

<template>
  <div>
    <label class="section-label">{{
      $t('exportBookings.columns.label')
    }}</label>
    <div class="checkbox-group columns">
      <div class="columns-list">
        <BaseCheckbox
          v-for="(label, key) in {
            all: $t('exportBookings.columns.all'),
            ...columns,
          }"
          :key="`export-${key}`"
          sm
          :model-value="key === 'all' ? selectAll : selectedColumns[key]"
          @update:modelValue="
            () => (key === 'all' ? toggleAllColumns() : toggleColumn(key))
          "
        >
          <span class="checkbox-label">{{ label }}</span>
        </BaseCheckbox>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/_colors.scss';
@import '@/styles/bookingList/booking-export.scss';
</style>
